<template>
    <b-card>
        <ratings key="officerMap" :loaded="loaded" :officers="officers" :roles="roles" :orders="orders"
            :order-types="orderTypes" />
    </b-card>
</template>
<script>
import ratings from './ratings'
export default {
    components: {
        ratings
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
    },
    mounted() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('company/fetch')
    },

    computed: {
        filteredOfficers() {
            return this.officers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        officers() {
            return this.$store.getters['analytics/officers']
        },
        roles() {
            return this.$store.getters['analytics/roles']
        },
        assetTypes() {
            return this.$store.getters['analytics/assetTypes']
        },
        orders() {
            console.log(
                this.$store.getters['analytics/orders'],
                'analytics/orders'
            )
            return this.$store.getters['analytics/orders']
        },

        orderTypes() {
            return this.$store.getters['analytics/orderTypes']
        },
        assets() {
            console.log()
            return this.$store.getters['analytics/assets']
        },
    },
    watch: {
        officers: {
            handler: function (val) {
                if (val) this.loaded = true
            },
            deep: true,
        },
    },
    async created() {
        await this.$store.dispatch('analytics/getDashboardData')
        this.loaded = true
        await this.$store.dispatch('analytics/getAnalytics')
    },
}

</script>